// import { useState, useEffect } from "react";
// import SmallProductCart from "../standartComponent/productComponent/smallProductCart";
// import css from "./main.module.css";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { addFilter } from "../../function/filtersSlice";
// import { db } from "../../firebase";
// import { getDocs, collection } from "firebase/firestore";
// import WithFieldData from "../HOK/withFieldData";
// import { HandySvg } from "handy-svg";
// import arrow from "../../svg/arrow.svg";

// const OneProdActions = ({
//   products: saleProducts,
//   setCartCounterC,
//   setLikeCounterC,
// }) => {
//   const [allProducts, setAllProducts] = useState([]);
//   const [actions, setActions] = useState([]);
//   const [combinedProducts, setCombinedProducts] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const [startX, setStartX] = useState(null);
//   const [endX, setEndX] = useState(null);
//   const [isDragging, setIsDragging] = useState(false);

//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   // 1️⃣ Завантаження продуктів і акцій
//   useEffect(() => {
//     const fetchAllProducts = async () => {
//       const snapshot = await getDocs(collection(db, "product"));
//       const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       setAllProducts(list);
//     };

//     const fetchActions = async () => {
//       const snapshot = await getDocs(collection(db, "actions"));
//       const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       setActions(list);
//     };

//     fetchAllProducts();
//     fetchActions();
//   }, []);

//   // 2️⃣ Формування комбінованого масиву
//   useEffect(() => {
//     if (allProducts.length && actions.length) {
//       const now = new Date();

//       const activeActionProducts = allProducts.flatMap((product) => {
//         const matchedAction = actions.find((action) => {
//           const start = action.startDate ? new Date(action.startDate) : null;
//           const end = new Date(action.endDate);

//           const matchesProduct = action.appliesTo?.products?.includes(
//             product.id
//           );

//           const productSeries = Array.isArray(product.series)
//             ? product.series
//             : [product.series];
//           const matchesSeries = productSeries?.some((ser) =>
//             action.appliesTo?.series?.includes(ser)
//           );

//           const productAuthors = Array.isArray(product.author)
//             ? product.author
//             : [product.author];
//           const matchesAuthor = productAuthors?.some((a) =>
//             action.appliesTo?.authors?.includes(a)
//           );

//           return (
//             (matchesProduct || matchesSeries || matchesAuthor) &&
//             (!start || now >= start) &&
//             now <= end
//           );
//         });

//         if (matchedAction) {
//           return {
//             ...product,
//             actionDiscountPercent: matchedAction.discountPercent,
//           };
//         } else {
//           return [];
//         }
//       });

//       const combined = [
//         ...saleProducts,
//         ...activeActionProducts.filter(
//           (p) => !saleProducts.some((sp) => sp.id === p.id)
//         ),
//       ];

//       setCombinedProducts(combined);
//       setCurrentIndex(0);
//     }
//   }, [allProducts, actions, saleProducts]);

//   // 3️⃣ Перехід до каталогу
//   const goToSales = () => {
//     dispatch(addFilter({ field: "sale", value: "true" }));
//     navigate("/catalog");
//   };

//   // 4️⃣ Перехід стрілкою/свайпом
//   const handleNext = () => {
//     setCurrentIndex((prev) => (prev + 1) % combinedProducts.length);
//   };

//   const handlePrev = () => {
//     setCurrentIndex((prev) =>
//       prev === 0 ? combinedProducts.length - 1 : prev - 1
//     );
//   };

//   // 5️⃣ Обробка touch
//   const handleTouchStart = (e) => {
//     setStartX(e.touches[0].clientX);
//     setEndX(null);
//   };

//   const handleTouchMove = (e) => {
//     if (startX !== null) {
//       setEndX(e.touches[0].clientX);
//     }
//   };

//   const handleTouchEnd = () => {
//     if (startX !== null && endX !== null) {
//       const delta = startX - endX;
//       if (delta > 50) {
//         handleNext();
//       } else if (delta < -50) {
//         handlePrev();
//       }
//     }
//     setStartX(null);
//     setEndX(null);
//   };

//   // 6️⃣ Обробка миші
//   const handleMouseDown = (e) => {
//     setIsDragging(true);
//     setStartX(e.clientX);
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging) {
//       setEndX(e.clientX);
//     }
//   };

//   const handleMouseUp = () => {
//     if (isDragging && startX !== null && endX !== null) {
//       const delta = startX - endX;
//       if (delta > 50) {
//         handleNext();
//       } else if (delta < -50) {
//         handlePrev();
//       }
//     }
//     setStartX(null);
//     setEndX(null);
//     setIsDragging(false);
//   };

//   return (
//     <div
//       className={css.oneProdWrapNew}
//       onTouchStart={handleTouchStart}
//       onTouchMove={handleTouchMove}
//       onTouchEnd={handleTouchEnd}
//       onMouseDown={handleMouseDown}
//       onMouseMove={handleMouseMove}
//       onMouseUp={handleMouseUp}
//       style={{ touchAction: "none", userSelect: "none" }}
//     >
//       <p className={css.nameOfAcr} onClick={goToSales}>
//         Всі акції
//       </p>

//       {combinedProducts.length ? (
//         <div className={css.sliderWrap}>
//           <SmallProductCart
//             el={combinedProducts[currentIndex]}
//             setCartCounterC={setCartCounterC}
//             setLikeCounterC={setLikeCounterC}
//           />
//           <HandySvg
//             src={arrow}
//             className={css.arrovIconBanner}
//             width="52"
//             height="49.56"
//             onClick={handleNext}
//           />
//         </div>
//       ) : (
//         <p>Акційних товарів зараз немає</p>
//       )}
//     </div>
//   );
// };

// export default WithFieldData("sale", "product", "true")(OneProdActions);

import { useState, useEffect } from "react";
import SmallProductCart from "../standartComponent/productComponent/smallProductCart";
import css from "./main.module.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addFilter } from "../../function/filtersSlice";
import { db } from "../../firebase";
import { getDocs, collection } from "firebase/firestore";
import WithFieldData from "../HOK/withFieldData";
import { HandySvg } from "handy-svg";
import arrow from "../../svg/arrow.svg";

const OneProdActions = ({
  products: saleProducts,
  setCartCounterC,
  setLikeCounterC,
}) => {
  const [allProducts, setAllProducts] = useState([]);
  const [actions, setActions] = useState([]);
  const [combinedProducts, setCombinedProducts] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [startX, setStartX] = useState(null);
  const [endX, setEndX] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // 1️⃣ Завантаження продуктів і акцій
  useEffect(() => {
    const fetchAllProducts = async () => {
      const snapshot = await getDocs(collection(db, "product"));
      const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setAllProducts(list);
    };

    const fetchActions = async () => {
      const snapshot = await getDocs(collection(db, "actions"));
      const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setActions(list);
    };

    fetchAllProducts();
    fetchActions();
  }, []);

  // 2️⃣ Формування комбінованого масиву
  useEffect(() => {
    if (allProducts.length && actions.length) {
      const now = new Date();

      const activeActionProducts = allProducts.flatMap((product) => {
        const matchedAction = actions.find((action) => {
          const start = action.startDate ? new Date(action.startDate) : null;
          const end = new Date(action.endDate);

          const matchesProduct = action.appliesTo?.products?.includes(
            product.id,
          );

          const productSeries = Array.isArray(product.series)
            ? product.series
            : [product.series];
          const matchesSeries = productSeries?.some((ser) =>
            action.appliesTo?.series?.includes(ser),
          );

          const productAuthors = Array.isArray(product.author)
            ? product.author
            : [product.author];
          const matchesAuthor = productAuthors?.some((a) =>
            action.appliesTo?.authors?.includes(a),
          );

          return (
            (matchesProduct || matchesSeries || matchesAuthor) &&
            (!start || now >= start) &&
            now <= end
          );
        });

        if (matchedAction) {
          return {
            ...product,
            actionDiscountPercent: matchedAction.discountPercent,
          };
        } else {
          return [];
        }
      });

      const combined = [
        ...saleProducts,
        ...activeActionProducts.filter(
          (p) => !saleProducts.some((sp) => sp.id === p.id),
        ),
      ];

      setCombinedProducts(combined);
      setCurrentIndex(0);
    }
  }, [allProducts, actions, saleProducts]);

  // 3️⃣ Перехід до каталогу
  const goToSales = () => {
    dispatch(addFilter({ field: "sale", value: "true" }));
    navigate("/catalog");
  };

  // 4️⃣ Перехід стрілкою/свайпом
  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % combinedProducts.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? combinedProducts.length - 1 : prev - 1,
    );
  };

  // 5️⃣ Обробка touch
  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
    setEndX(null);
  };

  const handleTouchMove = (e) => {
    if (startX !== null) {
      setEndX(e.touches[0].clientX);
    }
  };

  const handleTouchEnd = () => {
    if (startX !== null && endX !== null) {
      const delta = startX - endX;
      if (delta > 50) {
        handleNext();
      } else if (delta < -50) {
        handlePrev();
      }
    }
    setStartX(null);
    setEndX(null);
  };

  // 6️⃣ Обробка миші
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.clientX);
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setEndX(e.clientX);
    }
  };

  const handleMouseUp = () => {
    if (isDragging && startX !== null && endX !== null) {
      const delta = startX - endX;
      if (delta > 50) {
        handleNext();
      } else if (delta < -50) {
        handlePrev();
      }
    }
    setStartX(null);
    setEndX(null);
    setIsDragging(false);
  };

  return (
    <div
      className={css.oneProdWrapNew}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      style={{ touchAction: "pan-y pinch-zoom", userSelect: "none" }}
    >
      <p className={css.nameOfAcr} onClick={goToSales}>
        Всі акції
      </p>

      {combinedProducts.length ? (
        <div className={css.sliderWrap}>
          {/* <SmallProductCart
            el={combinedProducts[currentIndex]}
            setCartCounterC={setCartCounterC}
            setLikeCounterC={setLikeCounterC}
          /> */}
          <SmallProductCart
            key={
              combinedProducts[currentIndex]?.uid ||
              combinedProducts[currentIndex]?.id ||
              currentIndex
            }
            el={combinedProducts[currentIndex]}
            setCartCounterC={setCartCounterC}
            setLikeCounterC={setLikeCounterC}
          />
          <HandySvg
            src={arrow}
            className={css.arrovIconBanner}
            width="52"
            height="49.56"
            onClick={handleNext}
          />
        </div>
      ) : (
        <p>Акційних товарів зараз немає</p>
      )}
    </div>
  );
};

export default WithFieldData("sale", "product", "true")(OneProdActions);
